import { Link } from 'react-router-dom';
import { Card, CardActionArea, CardContent, Box, Typography, Chip, Stack } from '@mui/material';
import { formatDate } from '../utils/localeUtils';

const PURPLE = '#6a1b6d';

const BlogCard = ({ blog }) => (
  <Card
    elevation={0}
    sx={{
      border: '1px solid',
      borderColor: 'rgba(106,27,109,0.15)',
      borderRadius: 3,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      transition: 'box-shadow 0.2s',
      '&:hover': { boxShadow: '0 4px 20px rgba(106,27,109,0.12)' },
    }}
  >
    <CardActionArea
      component={Link}
      to={`/blogs/${blog.slug}`}
      sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
    >
      {blog.coverImage && (
        <Box
          component="img"
          src={blog.coverImage}
          alt={blog.title}
          sx={{ width: '100%', height: 160, objectFit: 'cover' }}
        />
      )}
      <CardContent sx={{ p: { xs: 2.5, md: 3 }, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {blog.tags?.length > 0 && (
          <Stack direction="row" spacing={0.5} sx={{ mb: 1, flexWrap: 'wrap', rowGap: 0.5 }}>
            {blog.tags.slice(0, 3).map((tag) => (
              <Chip
                key={tag}
                label={tag}
                size="small"
                sx={{ bgcolor: 'rgba(106,27,109,0.08)', color: PURPLE, fontWeight: 600, fontSize: '0.7rem' }}
              />
            ))}
          </Stack>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: PURPLE, mb: 0.75, lineHeight: 1.35 }}>
          {blog.title}
        </Typography>
        {blog.excerpt && (
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, flex: 1, mb: 1.5 }}>
            {blog.excerpt}
          </Typography>
        )}
        {blog.publishedAt && (
          <Typography variant="caption" color="text.secondary">
            {formatDate(blog.publishedAt)}
          </Typography>
        )}
      </CardContent>
    </CardActionArea>
  </Card>
);

export default BlogCard;
